<div
 id="badge"
 [ngClass]="{ default: count === 0, available: count > 0 && !warningStatus, warning: count > 0 && warningStatus }"
>
  <p>{{ count }}</p>
</div>
